export default "__VITE_ASSET__9WUWh$1K__"